/* "You may also like" and "Recently viewed". Both render nothing until there is
   something real to show, so a page never carries an empty shelf. */
(function () {
  'use strict';
  if (window.__meridianExtras) return;
  window.__meridianExtras = true;

  var RV_KEY = 'meridian:recently-viewed';
  var root = ((window.MeridianRoutes && window.MeridianRoutes.root) || '/').replace(/\/?$/, '/');

  function initRecs(scope) {
    (scope || document).querySelectorAll('[data-recs]').forEach(function (el) {
      if (el.dataset.loaded || el.querySelector('.rtile')) return;
      el.dataset.loaded = '1';
      /* Complementary products are the ones a merchant pairs by hand in Search
         and Discovery, and an empty answer means nobody has paired anything
         with this product yet. There is deliberately no fall back to related
         here: related returns substitutes, and this shelf's heading promises
         things that go with the product, so filling it that way put rival
         earbuds under "Everything that goes with it" on the draft. An empty
         answer hides the shelf instead, and it reappears on its own as the
         pairings are curated. */
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var found = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs]');
          if (found && found.innerHTML.trim()) el.innerHTML = found.innerHTML;
          else el.hidden = true;
        })
        .catch(function () { el.hidden = true; });
    });
  }

  function initRecentlyViewed(scope) {
    (scope || document).querySelectorAll('[data-recently-viewed]').forEach(function (sec) {
      var handles;
      try { handles = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { handles = []; }
      var exclude = sec.dataset.exclude;
      handles = handles.filter(function (h) { return h && h !== exclude; }).slice(0, parseInt(sec.dataset.limit, 10) || 8);
      if (!handles.length) return;

      Promise.all(handles.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=product-card-fragment')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (pages) {
        var html = pages.map(function (page) {
          if (!page) return '';
          var card = new DOMParser().parseFromString(page, 'text/html').querySelector('.pcard-host');
          return card ? card.outerHTML : '';
        }).join('');
        if (!html) return;
        sec.querySelector('[data-rv-track]').innerHTML = html;
        sec.hidden = false;
        // Let the rail re-measure its arrows now that it has content.
        window.dispatchEvent(new Event('resize'));
      });
    });
  }

  function init(scope) { initRecs(scope); initRecentlyViewed(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
